export const listingLabel = (property) => property.listing_type === 'sale' ? 'En venta' : 'En alquiler';
export const statusLabel = (status) => ({
    available: 'Disponible',
    sold: 'Vendida',
    rented: 'Alquilada',
}[status]);
export const formatPrice = (property) => {
    if (!property.price_amount)
        return 'Consultar precio';
    const value = Number(property.price_amount);
    const formatted = new Intl.NumberFormat('es-UY', { maximumFractionDigits: 0 }).format(value);
    return `${property.currency === 'USD' ? 'USD' : '$'} ${formatted}`;
};
